import React from 'react';
import ColorActions from './color-actions';
import {Trans} from 'react-i18next';
import styled from 'styled-components';
import {Color} from 'types/colors';
import { ColumnDef } from '@tanstack/table-core';

const columns: ColumnDef<Color>[] = [
  {
    header: r => <Trans i18nKey="colorsPage.name" />,
    accessorFn: row => row.name?.toLocaleUpperCase(),
    id: 'name',
    enableSorting: true,
    cell: r => r.getValue(),
  },
  {
    header: r => <Trans i18nKey="colorsPage.code" />,
    accessorFn: row => (
      <div >
        <ColorContainer color={row.code}></ColorContainer>
        <span className=" ms-3 ">{row.code}</span>
      </div>
    ),
    id: 'code',
    enableSorting: true,
    cell: r => r.getValue(),

  },
  {
    header: r => <Trans i18nKey="productPage.actions" />,
    accessorFn: row => <ColorActions color={row} />,
    id: 'action',
    enableSorting: false,
    cell: r => r.getValue(),

  },
];

export default columns;

const ColorContainer = styled.span`
  background-color: ${props => props.color};
  padding: 0.5rem;
  padding-right: 3rem;

`;
